import { Tag } from "antd";
import { getVerificationStatusColor } from "constants/tagColors";
import { VesselDataVerificationStatus } from "interfaces";

const LABEL: Record<VesselDataVerificationStatus, string> = {
  pending:      "pending",
  approved:     "approved",
  not_approved: "on hold",
};

export const VerificationStatusTag = ({
  status,
}: {
  status: VesselDataVerificationStatus;
}) => (
  <Tag color={getVerificationStatusColor(status)} style={{ margin: 0 }}>
    {LABEL[status]}
  </Tag>
);
